import { Smartphone } from "lucide-react"

import type { Stop } from "@/types/collections"
import { cn } from "@/lib/utils"

/**
 * Marks a stop time typed in the driver's app rather than derived from GPS. Deliberately quiet;
 * inferred stops get no badge.
 */
export function StopSourceBadge({ stop, className }: { stop: Stop; className?: string }) {
  if (stop.arrivalSource !== "trackpod" && stop.departureSource !== "trackpod") return null

  const both = stop.arrivalSource === "trackpod" && stop.departureSource === "trackpod"
  const which = both
    ? "Arrival and departure"
    : stop.arrivalSource === "trackpod"
      ? "Arrival"
      : "Departure"

  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 text-palette-jungleGreen400 align-middle",
        className,
      )}
      title={`${which} recorded by the driver in Track-POD. The vehicle's GPS never registered this stop, so this time is driver-entered rather than measured.`}
    >
      <Smartphone size={10} aria-hidden="true" />
      <span className="sr-only">{which} recorded by the driver in Track-POD</span>
    </span>
  )
}
